/**
 * Widget Réservations Locataire
 * Simple et fonctionnel
 */

import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Chip,
  Button,
  Paper
} from '@mui/material';
import {
  Event as EventIcon,
  CheckCircle as CompletedIcon,
  Schedule as PendingIcon,
  Cancel as CancelledIcon,
  Visibility as ViewIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import { DashboardWidget, StatusIndicator } from '../DashboardBase';
import { PERIOD_LABELS, formatDate } from '../../../constants/dashboardConstants';

const RenterReservationsWidget = ({ data, loading, period, onRefresh }) => {
  const navigate = useNavigate();

  

  const {
    total = 0,
    active = 0,
    completed = 0,
    cancelled = 0,
    by_status = {}
  } = data || {};

  const statusConfig = {
    pending: { label: 'En attente', icon: <PendingIcon />, color: 'warning' },
    confirmed: { label: 'Confirmées', icon: <EventIcon />, color: 'info' },
    active: { label: 'Actives', icon: <EventIcon />, color: 'success' },
    completed: { label: 'Terminées', icon: <CompletedIcon />, color: 'primary' },
    cancelled: { label: 'Annulées', icon: <CancelledIcon />, color: 'error' }
  };

  const handleViewAll = () => {
    navigate('/renter/reservations');
  };


};

export default RenterReservationsWidget;
